package pl.michal_cyran.brand_hub.subpages.dayMathAd.composables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaCirclePlus
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.FeaturedCardStyle
import pl.michal_cyran.brand_hub.IconBoxStyle
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun ExerciseCard(
    title: String,
    icon: @Composable () -> Unit,
    subtitle: String,
    modifier: Modifier = Modifier,
) {
    ColorMode.current.toSitePalette()

    Column(
        CardStyle.toModifier().then(modifier)
    ) {
        Box(IconBoxStyle.toModifier()) { icon() }

        P(
            Modifier
                .fontWeight(700)
                .margin(top=1.cssRem, bottom = 0.px)
                .color(ColorMode.current.toSitePalette().textMuted)
                .toAttrs()
        ) {
            Text(
                title
            )
        }

        P(
            Modifier
                .fontSize(0.875.cssRem)
                .lineHeight(1.25.cssRem)
                .toAttrs()
        ) {
            Text(
                subtitle
            )
        }
    }
}

@Composable
fun FeaturedExerciseCard(
    title: String,
    subtitle: String,
    featured: Boolean = false,
    modifier: Modifier = Modifier,
) {
    val cm = ColorMode.current.toSitePalette()

    Column(
        FeaturedCardStyle.toModifier().then(modifier),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(IconBoxStyle.toModifier()) {
            FaCirclePlus(
                size = IconSize.LG,
                modifier = Modifier.color(cm.textOnPrimary)
            )
        }

        H3 (
            Modifier
                .color(ColorMode.current.toSitePalette().textOnPrimary)
                .toAttrs()
        ) {
            Text(
                title
            )
        }

        P(
            Modifier
                .fontSize(0.875.cssRem)
                .lineHeight(1.25.cssRem)
                .color(cm.textOnPrimaryDim)
                .toAttrs()
        ) {
            Text(
                subtitle
            )
        }
    }
}

